/*eslint-env jquery*/
import React, { Component } from 'react'
import { ProjectListHeader } from '.';
import { ready } from '../utils';

class RadarChart extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.startChart = this.startChart.bind(this);
        this.generateChart = this.generateChart.bind(this);
    }
    componentDidMount() {
        ready(() => this.startChart(this.props.data));
    }
    componentDidUpdate() {
        this.startChart(this.props.data);
    }
    startChart(chartData) {
        if (!chartData) return null;
        const ChartJs = function () { };
        const self = this;

        ChartJs.prototype.respChart = function (selector, type, data, options) {
            var ctx = selector.get(0).getContext("2d");
            $(window).resize(() => {
                // eslint-disable-next-line
                new Chart(ctx, { type: 'bar', data: data, options: options });
            });
            // eslint-disable-next-line
            new Chart(ctx, { type: 'bar', data: data, options: options });
        }
        ChartJs.prototype.init = function () {
            this.respChart($("#" + self.props.id), 'Bar', self.generateChart(chartData), { height: 300, maintainAspectRatio: false });
        }
        $.ChartJs = new ChartJs();
        $.ChartJs.Constructor = ChartJs
        $.ChartJs.init();
    }
    getRandomColor(index) {
        return `rgba(0, 172, 224, 0.${index + 2})`;
    }
    generateChart(data) {
        let phases = [];
        for (let index = 0; index < data.indicators.length; index++) {
            const i = data.indicators[index];
            if (!(phases.length >= i.indicator.baselines.length))
                phases = Array.apply(null, { length: i.indicator.baselines.length }).map(Number.call, Number);
        }
        return {
            labels: data.indicators.map(i => i.indicator.measure),
            datasets: [
                ...phases.map((phase, index) => {
                    return ({
                        label: `Result phase ${index + 1}`,
                        borderColor: "rgba(131, 217, 229,1)",
                        pointBackgroundColor: "rgba(131, 217, 229,1)",
                        pointBorderColor: "#fff",
                        pointHoverBackgroundColor: "#fff",
                        pointHoverBorderColor: "rgba(131, 217, 229,1)",
                        backgroundColor: this.getRandomColor(index),
                        data: data.indicators.map(i => i.indicator.baselines[index] || 0)
                    })
                }),
                {
                    label: "Projected results",
                    backgroundColor: "rgba(179,181,198,0.2)",
                    borderColor: "rgba(179,181,198,1)",
                    pointBackgroundColor: "rgba(179,181,198,1)",
                    pointBorderColor: "#fff",
                    pointHoverBackgroundColor: "#fff",
                    pointHoverBorderColor: "rgba(179,181,198,1)",
                    data: data.indicators.map(i => i.result.input)
                }
            ]
        }
    }
    render() {
        return (
            <div className="row" style={{ marginBottom: 24 }}>
                <div className="col-12" style={{ marginBottom: 24 }}>
                    <ProjectListHeader title={this.props.title} description={this.props.description} />
                </div>
                <div className="col-12">
                    <div id="portlet7" className="panel-collapse collapse show">
                        <div className="portlet-body">
                            <canvas id={this.props.id} height="300"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

RadarChart.defaultProps = {
    data: {
        indicators: []
    }
}

export default RadarChart;


// WEBPACK FOOTER //
// ./src/components/BarChart.js